module.exports = ".help-box {\n  padding: 5px 0;\n  font-size: 12px;\n  color: #8a8a8a;\n  font-style: italic;\n}"